module.exports = __webpack_public_path__ + "static/media/cheese.fa5cb819.svg";